import React from 'react';

import { IWhitelabelFeesMessages } from 'src/explore/types/shoppe';

import styles from './index.module.sass';

export const DEFAULT_TAXES_AND_FEES_EXPLANATION =
  'Fees help cover variable carrier surcharges — including fuel and seasonal adjustments — and the extra operational care needed to deliver perishables reliably through weather and other disruptions beyond our control.';

// A WL merchant can charge a processing fee even with the handling-fee flag off, so
// "a fee is present" has to check both signals rather than just the flag.
export const hasWhitelabelFeesPresent = (
  enableWhitelabelHandlingFee?: boolean | null,
  merchantProcessingFeesTotalInCents?: number | null
): boolean => !!enableWhitelabelHandlingFee || !!merchantProcessingFeesTotalInCents;

export const taxesAndFeesLabel = ( hasFeesPresent: boolean ): string =>
  hasFeesPresent ? 'Taxes & Fees' : 'Taxes';

interface WhitelabelFeesExplanationProps {
  messages?: IWhitelabelFeesMessages | null;
}

export const WhitelabelFeesExplanation: React.FC<WhitelabelFeesExplanationProps> = ({
  messages,
}) => {
  const merchantMessage = messages?.merchantMessage || DEFAULT_TAXES_AND_FEES_EXPLANATION;
  const productMessages = ( messages?.productMessages || []).filter( Boolean ) as string[];

  return (
    <>
      <div>{merchantMessage}</div>
      {productMessages.map(( message ) => (
        <div className={styles.productMessage} key={message}>
          {message}
        </div>
      ))}
    </>
  );
};
